import React from 'react'
import { Link } from 'react-router-dom'
import type { ProductV2 } from './types'

interface ProductCardV2Props {
  product: ProductV2
  currentLang: 'zh' | 'en'
}

const ProductCardV2: React.FC<ProductCardV2Props> = ({ product, currentLang }) => {
  const isZh = currentLang === 'zh'
  const displayName = isZh ? product.name : (product.nameEn || product.name)
  const productUrl = `/${currentLang}/shop/${product.category}/v2/${product.productId || product._id}/${product.slug || 'product'}`
  const isOutOfStock = product.status === 'out_of_stock' || product.inventory === 0
  const isHidden = product.status && product.status !== 'active' && !isOutOfStock

  return (
    <Link to={productUrl} className="group block">
      {/* Square image */}
      <div className="relative aspect-square overflow-hidden bg-[#F6F4EE]">
        {product.images?.[0] ? (
          <img
            src={product.images[0]}
            alt={displayName}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
          />
        ) : (
          <div className="flex h-full w-full items-center justify-center text-xs text-black/30">
            No image
          </div>
        )}

        {isOutOfStock && (
          <div
            className="absolute left-3 top-3 bg-black px-3 py-1 text-[11px] text-white"
            style={{ letterSpacing: '0.2em' }}
          >
            {isZh ? '售完' : 'SOLD OUT'}
          </div>
        )}

        {isHidden && (
          <div
            className="absolute right-3 top-3 bg-white/90 px-2 py-0.5 text-[10px] text-black/70"
            style={{ letterSpacing: '0.15em' }}
          >
            {isZh ? '隱藏' : 'HIDDEN'}
          </div>
        )}
      </div>

      {/* Name + price */}
      <div className="pt-4 pb-2">
        <h3
          className="mb-1.5 text-sm leading-snug text-black/85"
          style={{ letterSpacing: '0.02em' }}
        >
          {displayName}
        </h3>
        <p
          className="text-sm text-black/70"
          style={{ fontFamily: "'EB Garamond', serif" }}
        >
          NT$ {product.price?.toLocaleString?.() ?? product.price}
        </p>
      </div>
    </Link>
  )
}

export default ProductCardV2
